import React from "react";
import PageHeader from "@/components/PageHeader";
import ItemsTable from "@/components/ItemsTable";
import { useDropdownOptions } from "@/hooks/useDropdownOptions";

export default function Quotes() {
  const { customerOpts, quoteStatuses } = useDropdownOptions();

  const columns = [
    { key: "title", label: "Quote", type: "text", required: true, placeholder: "Quote description" },
    { key: "customer_id", label: "Customer", type: "select", options: customerOpts, width: 220 },
    { key: "status", label: "Status", type: "select", options: quoteStatuses, width: 200 },
    { key: "amount", label: "Amount ($)", type: "number", width: 140 },
    { key: "date", label: "Date", type: "date", width: 160 },
    { key: "notes", label: "Notes", type: "text" },
  ];

  return (
    <div className="max-w-[1600px] mx-auto px-8 py-10">
      <PageHeader
        eyebrow="Quotes"
        title="Working & Sent"
        description="Quotes we're building and ones sent to customers for approval."
      />
      <ItemsTable
        endpoint="quotes"
        columns={columns}
        defaultItem={{ title: "", customer_id: "", status: "working on", notes: "" }}
        testIdPrefix="quotes"
        emptyLabel="No quotes yet."
      />
    </div>
  );
}
